import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { getDatabaseEnvironmentLabel } from "../utils/db_management_utils";
import "../styles/DbManagementStyles.css"
    
function DatabaseActionsModal(paramvalues: { handleClose: any, RowKey: string, group: string , selectedEnv: string, handleCopyDatabase: (group?: string) => void }) {

    var env_label = getDatabaseEnvironmentLabel(Number(paramvalues.selectedEnv));
    
    var header = `Actions - ${env_label} - Client: ${paramvalues.group}`

    const footerContent = (
        <div>
            <Button
                label="Close"
                icon="pi pi-times"
                onClick={() => paramvalues.handleClose()}
                className="p-button-primary green-background"
            />
        </div>
    );

    const CopyDatabaseClick = () => {
        paramvalues.handleClose()
        paramvalues.handleCopyDatabase(paramvalues.group);
    }

    if (env_label == "Unknown Environment" || env_label == "")
    {
        return (
            <>
                <Dialog header="No Environment Selected" visible={true} style={{ width: '350px' }} onHide={paramvalues.handleClose}></Dialog>
            </>
        )
    }
    else
    return(
        <>

            <Dialog header={header} visible={true} style={{ width: '510px' }} onHide={paramvalues.handleClose} footer={footerContent} >
            <div className="dialog-button-row">
                <div className="dialog-button-column">
                        <Button disabled={true} label="Run Allocation" className='p-button-outlined green-text' onClick={() => { alert(`Running Allocation for ${paramvalues.group}`) }} />
                        <Button disabled={true} label="Run Elig Calc" className='p-button-outlined  green-text' onClick={() => { alert(`Running Elig Calc for ${paramvalues.group}`) }} />
                        <Button label="Copy Database" className='p-button-outlined green-text' onClick={() => { CopyDatabaseClick() }} />
                        <Button disabled={true} label="Lock" className='p-button-outlined  green-text' onClick={() => { alert(`Database Locked for ${paramvalues.group}`) }} />
                        <Button disabled={true} label="Prod Nightly Schedules" className='p-button-outlined  green-text' onClick={() => { alert(`Running Nightly Schedules for ${paramvalues.group}`) }} />
                </div>

                <div className="dialog-button-column">
                        <Button disabled={true} label="Copy Batch" className='p-button-outlined  green-text' onClick={() => { alert(`Running Allocation for ${paramvalues.group}`) }} />
                        <Button disabled={true} label="Copy Template" className='p-button-outlined  green-text' onClick={() => { alert(`Running Elig Calc for ${paramvalues.group}`) }} />
                </div>
                </div>
            </Dialog>
      
        </>

    )
}

export default DatabaseActionsModal;